import React from "react";
import { WithDrawalCard, FieldInputDollar } from "../../../components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from "@fortawesome/pro-light-svg-icons";
import { Image } from "react-bootstrap";
import { get } from "lodash";
import {
  distributionModes,
  DISTRIBUTION_WITHDRAWAL_MODE,
  getAddressDisplay,
  getBankDisplay,
  getCodeOptions,
  getFullName,
} from "./DistributionConstantsAndFunctions";

const columns = [
  {
    label: "Recipient",
    width: "16.6%",
    columnName: "recipient",
  },
  {
    label: "Payment Details",
    width: "16.6%",
    columnName: "paymentDetails",
  },
  {
    label: "1099 Code",
    width: "16.6%",
    columnName: "code",
  },
  {
    label: "Tax",
    width: "12.5%",
    columnName: "tax",
  },
  {
    label: "Fee",
    width: "12.5%",
    columnName: "fee",
  },
  {
    label: "Penalty",
    width: "12.5%",
    columnName: "penalty",
  },
  {
    label: "Amount",
    width: "12.5%",
    columnName: "recipient",
  },
];

const HeadingAndTextComponent = ({
  headingText = "",
  contentText = "",
  style = {},
}) => (
  <div style={{ ...style }}>
    <div className="textHeading">{headingText}</div>
    <div className="textWord mt-2">{contentText}</div>
  </div>
);

function DistributionModeSummaryCard(props) {
  const { values, fields, employeeData } = props;
  const withdrawalRequestData = values;
  if (get(values, "withdrawalTransactions", []).length === 0) return <></>;
  return (
    <div className="basic-details-card">
      <div
        style={{
          display: "flex",
          justifyContent: "space-evenly",
          width: "100%",
        }}
      >
        {columns.map((_, ind) => (
          <div
            style={{
              width: _.width,
              color: "#919191",
              fontWeight: "600",
              fontSize: "16px",
              whiteSpace: "nowrap",
            }}
          >
            {_.label}
          </div>
        ))}
      </div>
      <>
        {get(values, "withdrawalTransactions", []).map((transaction_, ind) => {
          const isBeneficiary =
            transaction_.distributionMode ===
            DISTRIBUTION_WITHDRAWAL_MODE.beneficiary;
          const beneficiary = withdrawalRequestData?.beneficiaries.find(
            (x, ind) => x.id === transaction_.beneficiaryId
          );

          return (
            <>
              {/* <div>
                {
                  columns.map((_, ind) => (
                    <div style={{ color: "#919191", fontWeight: "600", fontSize: "16px" }}>
                      {_.label}
                    </div>
                  )
                  )
                }
              </div> */}
              <WithDrawalCard cssStyle={{ marginBottom: "15px" }}>
                <div style={{ width: columns[0].width }}>
                  <div>
                    {" "}
                    {isBeneficiary
                      ? beneficiary?.name
                      : getFullName(employeeData)}
                  </div>
                  <div>{distributionModes[transaction_?.distributionMode]}</div>
                </div>

                <div style={{ width: columns[1].width }}>
                  <div>
                    {transaction_.choosePaymentMethod === 2 ? "EFT" : "Check"}
                  </div>
                  <div>
                    {transaction_.choosePaymentMethod === 2
                      ? getBankDisplay(transaction_.bankInformation)
                      : getAddressDisplay(transaction_.address)}
                  </div>
                </div>

                <div
                  style={{
                    width: columns[2].width,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {getCodeOptions(transaction_)[transaction_.code]}
                </div>

                <div style={{ width: columns[3].width }}>
                  ${" "}
                  {get(transaction_, "stateTax", 0) +
                    get(transaction_, "federalTax", 0)}
                </div>

                <div style={{ width: columns[4].width }}>
                  ${" "}
                  {get(transaction_, "checkFee", 0) +
                    get(transaction_, "eftFee", 0) +
                    get(transaction_, "rollOverFee", 0)}
                </div>

                <div style={{ width: columns[5].width }}>
                  {get(transaction_, "WaiveOffLimitApplicable", false)
                    ? `${get(transaction_, [fields.waiveOffLimit], 0)} %`
                    : "-"}{" "}
                </div>

                <div style={{ width: columns[6].width }}>
                  $ {get(transaction_, fields.requestedAmount, 0)}
                </div>
              </WithDrawalCard>
            </>
          );
        })}
      </>
      <div className="d-flex fw-600 w-100 justify-content-between">
        <div>
          Withdrawal Amount
          <FontAwesomeIcon
            icon={faExclamationCircle}
            color="#000"
            className="ml-2"
          />
        </div>
        <div>$23472</div>
      </div>
    </div>
  );
}

export default DistributionModeSummaryCard;
